import * as React from 'react';

import styled from 'styled-components';

import DropdownItem, { DropdownItemProps } from '../dropdown-item';

import Flex from '@components/layout/flex';
import UnselectedIcon from '@components/basics/icons/unselected';
import CompletedIcon from '@components/basics/icons/achievements-icons/completed';

interface DropdownItemCheckProps extends DropdownItemProps {
  className?: string;
  checked: boolean;
  hasChanges?: boolean;
  isDark?: boolean;
  onChange?: (value: boolean) => void;
}

const DropdownItemCheck: React.FC<DropdownItemCheckProps> = (props) => {
  const handleClick = () => {
    if (props.onChange) {
      props.onChange(!props.checked);
    }
  };

  return (
    <DropdownItem
      className={`${props.className || ''}`}
      onClick={handleClick}
      decoration={props.decoration}
      hasActive={props.hasChanges}
      isDark={props.isDark}
    >
      <Flex justifyContent="space-between" alignItems="center" gap={10}>
        <div
          className={`dropdown-item-check-content ${
            props.hasChanges ? 'has-changes' : ''
          }`}
        >
          {props.children}
        </div>
        <CheckContainer>
          {props.checked ? (
            <CompletedIcon className="dropdown-item-check-icon" />
          ) : (
            <UnselectedIcon
              isDark={props.hasChanges}
              className="dropdown-item-check-icon"
            />
          )}
        </CheckContainer>
      </Flex>
    </DropdownItem>
  );
};

export default styled(DropdownItemCheck)`
  justify-content: space-between;

  .dropdown-item-check-content {
    flex-grow: 0;
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .has-changes {
    color: ${({ theme }) => theme.colors.differentBackground};
  }
`;

const CheckContainer = styled.div`
  height: 24px;

  .dropdown-item-check-icon {
    width: 24px;
    height: 24px;
  }
`;
